import { cx } from "../../lib/cx.js";
import { Button } from "../Button/Button.js";
/* empty css               */
import { useLayoutEffect, useRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Pagination/Pagination.tsx
var defaultPageLabel = (page, pageCount) => `Page ${page} of ${pageCount}`;
/**
* Previous, "Page X of Y", Next: moves through a paged list (Users, Pay history
* uploads). A navigation landmark; the position is announced when it changes, and focus
* stays on a button when the one pressed becomes disabled at either end.
*/
function Pagination({ page, pageCount, onPageChange, size = "sm", singlePage = "hide", previousLabel = "Previous", nextLabel = "Next", pageLabel = defaultPageLabel, "aria-label": ariaLabel = "Pagination", className, ...rest }) {
	const count = Math.max(1, pageCount);
	const current = Math.min(Math.max(1, page), count);
	const previousRef = useRef(null);
	const nextRef = useRef(null);
	const pressed = useRef(null);
	useLayoutEffect(() => {
		const which = pressed.current;
		pressed.current = null;
		if (!which) return;
		const [own, other] = which === "next" ? [nextRef, previousRef] : [previousRef, nextRef];
		if (own.current?.disabled) other.current?.focus();
	}, [current]);
	if (count <= 1 && singlePage === "hide") return null;
	const go = (which) => {
		pressed.current = which;
		onPageChange(which === "next" ? current + 1 : current - 1);
	};
	return /* @__PURE__ */ jsxs("nav", {
		...rest,
		className: cx("ds-pagination", className),
		"aria-label": ariaLabel,
		children: [
			/* @__PURE__ */ jsx(Button, {
				ref: previousRef,
				variant: "secondary",
				size,
				disabled: current <= 1,
				onClick: () => go("previous"),
				children: previousLabel
			}),
			/* @__PURE__ */ jsx("span", {
				className: "ds-pagination__label",
				"aria-live": "polite",
				"aria-atomic": "true",
				children: pageLabel(current, count)
			}),
			/* @__PURE__ */ jsx(Button, {
				ref: nextRef,
				variant: "secondary",
				size,
				disabled: current >= count,
				onClick: () => go("next"),
				children: nextLabel
			})
		]
	});
}
//#endregion
export { Pagination };

//# sourceMappingURL=Pagination.js.map